import React, { useState } from "react";

const AssignmentView = () => {
  const [questions, setQuestions] = useState([
    {
      question: "",
      file: null,
      options: ["", "", "", ""],
      correctOption: null,
    },
  ]);

  const handleOptionChange = (qIndex, oIndex, value) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].options[oIndex] = value;
    setQuestions(newQuestions);
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index].question = value;
    setQuestions(newQuestions);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md m-3">
      <h1 className="text-[20px] font-bold text-[#400167] font-satoshi mb-4">
        VCL Assessment 1
      </h1>
      <form>
        {questions.map((q, qIndex) => (
          <div key={qIndex} className="mb-8">
            <div key={qIndex} className="mb-8">
              <div className="mb-12">
                <label
                  className="block text-[#400167] text-[16px] font-semibold mb-3 font-satoshi"
                  htmlFor={`question${qIndex}`}
                >
                  Question {qIndex + 1}
                </label>
                <input
                  id={`question${qIndex}`}
                  type="text"
                  placeholder="Write course title"
                  value={q.question}
                  onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
                  className="shadow-sm appearance-none border border-[#400167] rounded w-[683.89px] py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <label className="block mb-4 font-satoshi">
                <span className="font-bold text-[20px] text-[#400167]">
                  Options
                </span>{" "}
                {/* <span className="text-[#55465F]">(Tick the right answer)</span> */}
              </label>
              {q.options.map((option, oIndex) => (
                <>
                  <label className="mr-4 mb-2 font-semibold text-[16px] text-[#4D4F51]">{`Option ${String.fromCharCode(
                    65 + oIndex
                  )}`}</label>
                  <div
                    key={oIndex}
                    className="flex items-center mb-8  border rounded w-[683.89px] py-2 px-3 my-2"
                  >
                    <input
                      type="text"
                      placeholder="Answer"
                      value={option}
                      onChange={(e) =>
                        handleOptionChange(qIndex, oIndex, e.target.value)
                      }
                      className="appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    {/* <input
                      type="radio"
                      name={`correctOption${qIndex}`}
                      checked={q.correctOption === oIndex}
                      onChange={(e) =>
                        handleCorrectOptionChange(
                          qIndex,
                          oIndex,
                          e.target.value
                        )
                      }
                      className="mr-2"
                    /> */}
                  </div>
                </>
              ))}
            </div>
          </div>
        ))}
        <button
          type="submit"
          className="py-2 px-4 text-black rounded-lg underline font-semibold"
        >
          View more Question
        </button>
      </form>
    </div>
  );
};

export default AssignmentView;
